export const formatDate = (date: string): string => {
    if (!date) return '-'

    const d = typeof date === 'string' ? new Date(date) : date
    return d.toLocaleString('id-ID', {
        day: '2-digit',
        month: 'short',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
    });
}
export const formatDateOnly = (date: string): string => {
    if (!date) return '-'

    const d = typeof date === 'string' ? new Date(date) : date
    return d.toLocaleString('id-ID', {
        day: '2-digit',
        month: 'short',
        year: 'numeric',
    });
}

export const formatDateFull = (date: string | Date): string => {
    if (!date) return '-'

    const d = typeof date === 'string' ? new Date(date) : date
    
    if (isNaN(d.getTime())) return '-'

    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    const hours = String(d.getHours()).padStart(2, '0');
    const minutes = String(d.getMinutes()).padStart(2, '0');
    const seconds = String(d.getSeconds()).padStart(2, '0');

    return `${year}-${month}-${day}, ${hours}.${minutes}.${seconds}`;
}